import Route from '@ember/routing/route';
import { type Registry as Services, service } from '@ember/service';
import type MarketCustomReportingDashboardController from 'lumen/controllers/market/custom-reporting/dashboard';
import type { LookerDashboard } from 'lumen/models';
import type { Transition } from 'lumen/services/transition';

type Model = LookerDashboard | undefined;

type Params = {
  dashboard_id: string;
};

export default class MarketCustomReportingDashboardRoute extends Route {
  @service declare alerting: Services['alerting'];
  @service declare customReporting: Services['custom-reporting'];
  @service declare errorTracking: Services['error-tracking'];
  @service('looker-embed-session')
  declare lookerEmbedSession: Services['looker-embed-session'];
  @service declare router: Services['router'];
  @service declare store: Services['store'];

  deactivate(): void {
    this.customReporting.sidebarOpen = true;
    this.customReporting.selectedDashboard = undefined;
    this.lookerEmbedSession.onSessionExpired = undefined;
  }

  async model({ dashboard_id }: Params): Promise<Model> {
    try {
      const dashboard = await this.store.findRecord<LookerDashboard>(
        'looker-dashboard',
        dashboard_id,
      );

      return dashboard;
    } catch (error) {
      this.errorTracking.captureException(error);
      // eslint-disable-next-line @typescript-eslint/no-floating-promises
      this.alerting.showErrorAlert();
      this.router.transitionTo('market.custom-reporting.index');
      return undefined;
    }
  }

  resetController(controller: MarketCustomReportingDashboardController): void {
    void controller.acquireEmbedUrlTask.cancelAll();
    controller.reset();
  }

  setupController(
    controller: MarketCustomReportingDashboardController,
    model: Model,
    transition: Transition,
  ): void {
    super.setupController(controller, model, transition);

    this.customReporting.sidebarOpen = false;
    this.customReporting.dashboardLoading = true;
    this.customReporting.selectedDashboard = model;

    this.lookerEmbedSession.onSessionExpired = (): void => {
      void controller.acquireEmbedUrlTask.perform();
    };
    void controller.acquireEmbedUrlTask.perform();
  }
}
